import { useNavigate } from "react-router-dom"
import { Typography } from "@mui/material"

import StyledPaper from "/components/paper"

import statsImage from '/assets/dashboard/statistics.png'

const Statistics = () => {

  const navigate = useNavigate()

  return (
    <StyledPaper width={250} height={250}>
      <div onClick={() => navigate("/statistics")} className="link flex flex-col items-center justify-top h-full">
        <Typography variant="h5">Statistics</Typography>
      </div>
      <div onClick={() => navigate("/statistics")} className="link relative">
        <img src={statsImage} style={{ position: "absolute", left: "50%", bottom: 20, height: "150px", display: "inline-block", transform: "translateX(-50%)", filter: "drop-shadow(0 8px 12px rgba(0, 0, 0, 0.5))" }} />
      </div>
    </StyledPaper>
  )
}

export default Statistics